/**
 * Environment variables
 */
export const Env = {
  NODE_ENV: process.env.REACT_APP_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  SENDBIRD_CHAT_ID: process.env.REACT_APP_SENDBIRD_CHAT_APP_ID,
  NOTIFICATION_CHANNEL_ID: process.env.REACT_APP_SENDBIRD_NOTIFICATIONS_CHANNEL_ID,
  CENTRAL_INTAKE_LINK: process.env.REACT_APP_CENTRAL_INTAKE_LINK,
  PAC_IQ_DOMO_LINK: process.env.REACT_APP_PAC_IQ_DOMO_LINK,
  PUBLIC_DOMO_LINK: process.env.REACT_APP_DOMO_PUBLIC_LINK,
  TASKLIST_CHANNEL_ID: process.env.REACT_APP_TASKLIST_NOTIFICATIONS_CHANNEL_ID,
  AUTO_LOGOUT_TIMEOUT_DURATION: process.env.REACT_APP_AUTO_LOGOUT_TIMEOUT_DURATION,
  SIGNALR_API_URL: process.env.REACT_APP_SIGNALR_API_URL,
  PLAYWRIGHT_USERNAME: process.env.REACT_APP_PLAYWRIGHT_USERNAME,
  PLAYWRIGHT_PASS: process.env.REACT_APP_PLAYWRIGHT_PASS,
  SSO_CALLBACK_URL: process.env.REACT_APP_SSO_CALLBACK_URL,
  SSO_CLIENT_ID: process.env.REACT_APP_SSO_CLIENT_ID,
  SSO_IDP_LOGOUT_URLS: process.env.REACT_APP_SSO_IDP_LOGOUT_URLS,
  // Azure Maps (Geomapping #16173). Subscription key is the simplest dev path;
  // production should prefer an Entra token or a backend tile proxy so the key
  // is never shipped to the browser. See the Geomapping setup checklist.
  AZURE_MAPS_SUBSCRIPTION_KEY: process.env.REACT_APP_AZURE_MAPS_KEY,
  AZURE_MAPS_CLIENT_ID: process.env.REACT_APP_AZURE_MAPS_CLIENT_ID,
  // TEMPORARY pilot gate (reverts at GA): comma-separated org ids allowed to see CRM,
  // Leads and the Task Gate template toggle. Independent per feature. See pilotOrgAccess.ts.
  CRM_ORG_IDS: process.env.REACT_APP_CRM_ORG_IDS,
  LEADS_ORG_IDS: process.env.REACT_APP_LEADS_ORG_IDS,
  TASKGATE_ORG_IDS: process.env.REACT_APP_TASKGATE_ORG_IDS,

  isProd() {
    return this.NODE_ENV === 'production'
  },
  isDev() {
    return this.NODE_ENV === 'development'
  },
  isTest() {
    return this.NODE_ENV === 'test'
  },
  isStage() {
    return this.NODE_ENV === 'stage'
  },
  isLocal() {
    return this.NODE_ENV === 'local'
  },
}

export default Env
